import React from 'react';
import { SEO } from './components/SEO';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/landing/Hero';
import { WhyFailed } from './components/landing/WhyFailed';
import { TheProduct } from './components/landing/TheProduct';
import { WhatYouGet } from './components/landing/WhatYouGet';
import { Bonuses } from './components/landing/Bonuses';
import { FAQ } from './components/landing/FAQ';
import { OfferCTA } from './components/landing/OfferCTA';
import { StickyCTA } from './components/landing/StickyCTA';
import { Footer } from './components/landing/Footer';
export function App() {
  return <main className="min-h-screen bg-slate-50 font-sans selection:bg-orange-100 selection:text-orange-900 pb-20 md:pb-0" data-id="element-0">
      <SEO data-id="element-1" />
      <MetaPixel data-id="element-2" />
      <Hero data-id="element-3" />
      <WhyFailed data-id="element-4" />
      <TheProduct data-id="element-5" />
      <WhatYouGet data-id="element-6" />
      <Bonuses data-id="element-7" />
      <OfferCTA data-id="element-8" />
      <FAQ data-id="element-9" />
      <Footer data-id="element-10" />
      <StickyCTA data-id="element-11" />
    </main>;
}